export default __webpack_public_path__ + "static/media/036-speaker.5ed38a4c.svg";